import React, { useState } from 'react';
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'

const ProductGallery = ({ images }) => {
    const [activeImage, setActiveImage] = useState(0);

    console.log('ProductGallery received images:', images);

    // Show placeholder if no images
    if (!images || images.length === 0) {
        return (
            <div className="shop-single-slider">
                <div className="slider-main">
                    <div style={{
                        padding: '80px 20px',
                        textAlign: 'center',
                        background: '#f8f8f8',
                        border: '1px dashed #ddd',
                        borderRadius: '8px'
                    }}>
                        <p style={{ color: '#999', fontSize: '16px' }}>Ürün görseli yükleniyor...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="shop-single-slider">
            <div className="slider-main">
                <Zoom>
                    <img src={images[activeImage]} alt={`Product ${activeImage + 1}`} />
                </Zoom>
            </div>
            {images.length > 1 && (
                <div className="slider-thumbs">
                    {images.map((image, index) => (
                        <div
                            key={index}
                            className={`thumb-item ${index === activeImage ? 'active' : ''}`}
                            onClick={() => setActiveImage(index)}
                            style={{ cursor: 'pointer' }}
                        >
                            <img src={image} alt={`Thumbnail ${index + 1}`} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ProductGallery;
